var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCplusplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 288,
    viewBox: "0 0 256 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.987 84.72C255.985 79.89 254.95 75.622 252.858 71.959C250.803 68.357 247.724 65.338 243.596 62.951C209.515 43.332 175.401 23.773 141.332 4.13395C132.147 -1.16005 123.241 -0.967046 114.124 4.40295C100.559 12.39 32.6433 51.237 12.4053 62.94C4.07065 67.757 0.0150245 75.129 0.0130213 84.711C0 124.166 0.0130213 163.62 0 203.076C0.00200327 207.8 0.992621 211.985 2.99289 215.593C5.04924 219.304 8.17034 222.406 12.3942 224.847C32.6333 236.55 100.558 275.394 114.12 283.383C123.241 288.756 132.147 288.948 141.335 283.652C175.405 264.012 209.521 244.454 243.607 224.835C247.831 222.395 250.952 219.291 253.008 215.583C255.005 211.975 255.998 207.79 256 203.065C256 203.065 256 124.176 255.987 84.72Z",
    fill: "#5C8DBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.391 143.509L2.99219 215.593C5.04855 219.304 8.16964 222.406 12.3935 224.847C32.6326 236.55 100.557 275.394 114.12 283.383C123.241 288.756 132.146 288.948 141.334 283.652C175.405 264.012 209.52 244.454 243.606 224.835C247.83 222.395 250.951 219.291 253.007 215.583L128.391 143.509Z",
    fill: "#1A4674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.25 164.861C98.5469 177.579 112.264 186.157 128 186.157C143.833 186.157 157.628 177.47 164.888 164.616L128.392 143.509L91.25 164.861Z",
    fill: "#1A4674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.988 84.72C255.986 79.89 254.951 75.622 252.859 71.959L128.393 143.509L253.009 215.583C255.006 211.975 255.999 207.79 256.001 203.065C256.001 203.065 256.001 124.176 255.988 84.72Z",
    fill: "#1B598E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.135 148.661H239.397V158.385H229.657V148.661H219.92V138.94H229.657V129.218H239.397V138.94H249.135V148.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.601 148.661H203.864V158.385H194.127V148.661H184.389V138.94H194.127V129.218H203.864V138.94H213.601V148.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.888 164.616C157.629 177.47 143.833 186.157 128 186.157C112.264 186.157 98.547 177.579 91.2501 164.861C87.7053 158.681 85.667 151.526 85.667 143.893C85.667 120.552 104.621 101.63 128 101.63C143.635 101.63 157.28 110.101 164.613 122.689L201.614 101.417C186.907 76.0706 159.449 59.0186 128 59.0186C81.0475 59.0186 42.9863 97.0186 42.9863 143.893C42.9863 159.271 47.084 173.692 54.2457 186.131C68.9157 211.611 96.4516 228.768 128 228.768C159.607 228.768 187.186 211.542 201.835 185.987L164.888 164.616Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 288,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCplusplus);
export default __webpack_public_path__ + "static/media/cplusplus.3398ef505c35b160f8f737a0555dd38d.svg";
export { ForwardRef as ReactComponent };